<template>
  <div class="my-info-browsinghistory">
    <div class="f-nav">
      <!-- 订单 -->
      <div
        :class="['nav', changeType == 'd' ? 'active-nav' : '']"
        @click="change_type('d')"
      >
        <div class="nav-block">
          <div>订单</div>
          <div
            :class="[
              'nav',
              changeType == 'd' ? 'change-line-active' : 'change-line',
            ]"
          ></div>
        </div>
      </div>
      <!-- 买卖 -->
      <div :class="['nav', changeType == 'm' ? 'active-nav' : '']">
        <div class="nav-block" @click="change_type('m')">
          <div>买卖</div>
          <div
            :class="[
              'nav',
              changeType == 'm' ? 'change-line-active' : 'change-line',
            ]"
          ></div>
        </div>
      </div>
      <!-- 租约 -->
      <div
        :class="['nav', changeType == 'z' ? 'active-nav' : '']"
        @click="change_type('z')"
      >
        <div class="nav-block">
          <div>租约</div>
          <div
            :class="[
              'nav',
              changeType == 'z' ? 'change-line-active' : 'change-line',
            ]"
          ></div>
        </div>
      </div>
    </div>

    <div>
      <div class="contract-list" v-show="changeType == 'd'">
        <div
          class="contract-block"
          v-for="(item, index) in DQ_list"
          :key="index"
        >
          <div class="head">
            <div class="head-left">
              <div v-if="item.type == 'mmrw'">买卖合同</div>
              <div v-if="item.type == 'mmls_rw'">买卖两书</div>
              <div v-if="item.type == 'mmjy'">买卖物业交验</div>
              <div v-if="item.type == 'zulin_new'">租赁合同</div>
              <div v-if="item.type == 'zlls'">租赁两书</div>
              <div v-if="item.type == 'zljy'">租赁物业交验</div>
              <div v-if="item.type == 'shangye'">商业租赁合同</div>
            </div>
            <div class="head-right-new">{{ item.qyzt }}</div>
          </div>
          <div class="body">
            <div class="line">
              <div class="line-pram">合同编号</div>
              <div class="line-text">{{ item.htbh }}</div>
            </div>
            <div class="line">
              <div class="line-pram">物业地址</div>
              <div class="line-text">
                {{ item.adress }}
              </div>
            </div>
            <div class="line">
              <div class="line-pram">户型</div>
              <div class="line-text">{{ item.huxing }}</div>
            </div>

            <div class="line">
              <div class="line-pram">面积</div>
              <div class="line-text">{{ item.mianji }}m²</div>
            </div>

            <div class="line">
              <div class="line-pram">价格</div>
              <div class="line-text fontcolor">{{ item.jiage }}元</div>
            </div>

            <div class="line">
              <div class="line-pram">签约时间</div>
              <div class="line-text">{{ item.qyrq }}</div>
            </div>
          </div>
          <div class="active">
            <div class="active-line">
              <div class="active-button-block">
                <div class="active-button" @click="goTobesigned(item)">
                  签约进度
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="contract-list" v-show="changeType == 'm'">
        <div
          class="contract-block"
          v-for="(item, index) in YQ_list_mm"
          :key="index"
        >
          <div class="head">
            <div class="head-left">
              <div v-if="item.type == 'mmrw'">买卖合同</div>
              <div v-if="item.type == 'mmls_rw'">买卖两书</div>
              <div v-if="item.type == 'mmjy'">买卖物业交验</div>
              <div v-if="item.type == 'zulin_new'">租赁合同</div>
              <div v-if="item.type == 'zlls'">租赁两书</div>
              <div v-if="item.type == 'zljy'">租赁物业交验</div>
              <div v-if="item.type == 'shangye'">商业租赁合同</div>
            </div>
            <div class="head-right-new">{{ item.qyzt }}</div>
          </div>
          <div class="body">
            <div class="line">
              <div class="line-pram">合同编号</div>
              <div class="line-text">{{ item.htbh }}</div>
            </div>
            <div class="line">
              <div class="line-pram">物业地址</div>
              <div class="line-text">
                {{ item.adress }}
              </div>
            </div>
            <div class="line">
              <div class="line-pram">户型</div>
              <div class="line-text">{{ item.huxing }}</div>
            </div>

            <div class="line">
              <div class="line-pram">面积</div>
              <div class="line-text">{{ item.mianji }}m²</div>
            </div>

            <div class="line">
              <div class="line-pram">价格</div>
              <div class="line-text fontcolor">{{ item.jiage }}元</div>
            </div>

            <div class="line">
              <div class="line-pram">签约时间</div>
              <div class="line-text">{{ item.qyrq }}</div>
            </div>
          </div>
          <div class="active">
            <div class="active-line">
              <div class="active-button-block">
                <div v-if="item.qyzt == '签约完成'" class="active-button buttoned" @click="getHT(item)">查看盖章合同</div>
                <div v-if="item.qyzt == '签约完成'" class="active-button buttoned" @click="downHT(item)">下载盖章合同</div>
                <div v-if="item.qyzt != '签约完成'" class="active-button buttoned" @click="getHT(item)">
                  查看合同
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="contract-list" v-show="changeType == 'z'">
        <div
          class="contract-block"
          v-for="(item, index) in YQ_list_zy"
          :key="index"
        >
          <div class="head">
            <div class="head-left">
              <div v-if="item.type == 'mmrw'">买卖合同</div>
              <div v-if="item.type == 'mmls_rw'">买卖两书</div>
              <div v-if="item.type == 'mmjy'">买卖物业交验</div>
              <div v-if="item.type == 'zulin_new'">租赁合同</div>
              <div v-if="item.type == 'zlls'">租赁两书</div>
              <div v-if="item.type == 'zljy'">租赁物业交验</div>
              <div v-if="item.type == 'shangye'">商业租赁合同</div>
            </div>
            <div class="head-right-new">{{ item.qyzt }}</div>
          </div>
          <div class="body">
            <div class="line">
              <div class="line-pram">合同编号</div>
              <div class="line-text">{{ item.htbh }}</div>
            </div>
            <div class="line">
              <div class="line-pram">物业地址</div>
              <div class="line-text">
                {{ item.adress }}
              </div>
            </div>
            <div class="line">
              <div class="line-pram">户型</div>
              <div class="line-text">{{ item.huxing }}</div>
            </div>

            <div class="line">
              <div class="line-pram">面积</div>
              <div class="line-text">{{ item.mianji }}m²</div>
            </div>

            <div class="line">
              <div class="line-pram">价格</div>
              <div class="line-text fontcolor">{{ item.jiage }}元</div>
            </div>

            <div class="line">
              <div class="line-pram">签约时间</div>
              <div class="line-text">{{ item.qyrq }}</div>
            </div>
          </div>
          <div class="active">
            <div class="active-line">
              <div class="active-button-block">
                 <div v-if="item.qyzt=='签约完成'" class="active-button buttoned" @click="getHT(item)">查看盖章合同</div>
                  <div v-if="item.qyzt == '签约完成'" class="active-button buttoned" @click="downHT(item)">下载盖章合同</div>
                <div v-if="item.qyzt != '签约完成'" class="active-button buttoned" @click="getHT(item)">
                  查看合同
                </div>
              </div>
            </div>
          </div>
          <!-- 权证进度 -->
          <!-- <div class="active">
            <div class="active-line">
              <div class="active-pram">权证进度</div>
              <div class="progress-block">
                <div class="progress-line">
                  <div class="p-pram">
                    <div class="point"></div>
                    <div class="line"></div>
                  </div>
                  <div class="p-text">
                    <div class="p-time">2021-9-9</div>
                    <div class="p-statu">交税过户</div>
                  </div>
                </div>
                <div class="progress-line">
                  <div class="p-pram">
                    <div class="point"></div>
                    <div class="line"></div>
                  </div>
                  <div class="p-text">
                    <div class="p-time">2021-9-9</div>
                    <div class="p-statu">交税过户</div>
                  </div>
                </div>
              </div>
              <div class="active-button-block">
                <div class="active-button">合同详情</div>
                <div class="active-button">收支详情</div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import actions from "../../common/test.js";
import util from "../../common/util.js";
import houseItem from "../../component/houseItem.vue";
export default {
  components: { houseItem },
  data() {
    return {
      list: [],
      changeType: "d",
      YQ_list_mm: [],
      YQ_list_zy: [],
      DQ_list: [],
    };
  },
  created() {
    this.$store.commit("changeTitle", "合同订单");
    // util.hideLoading();
  },
  updated() {},
  computed: {},
  watch: {},
  mounted() {
    this.get_dq_list();
    this.get_yq_list_mm();
    this.get_yq_list_zy();
  },
  methods: {
    get_yq_list_mm() {
      let data = {
        type: "mm",
        gzhid: util.getLocalStorage("openid"),
      };
      actions.contract_YQ(data).then((res) => {
        console.log(res);
        this.YQ_list_mm = res.content;
      });
    },
    get_yq_list_zy() {
      let data = {
        type: "zu",
        gzhid: util.getLocalStorage("openid"),
      };
      actions.contract_YQ(data).then((res) => {
        console.log(res);
        this.YQ_list_zy = res.content;
      });
    },
    get_dq_list() {
      let data = {
        gzhid: util.getLocalStorage("openid"),
      };
      actions.contract_DQ(data).then((res) => {
        console.log(res);
        this.DQ_list = res.content;
      });
    },
    handleHosue(type, house) {
      if (type == "detail") {
        this.$router.push({
          name: "detail",
          params: { id: house.id, type: this.type },
          query: this.$route.query,
        });
      }
    },
    change_type(data) {
      this.changeType = data;
    },
    goTobesigned(data) {
      console.log(data);
      this.$router.push({
        name: "tobesigned",
        query: data,
      });
    },
    getHT(info){
            let data = {
        rw_id: info.rw_id,
      };
      actions.contract_FJ(data).then((res) => {
        this.$router.push({ name: "facescan", query: { url: res.content } });
      });
    },
    downHT(info){
        let data = {
        rw_id: info.rw_id,
      };
       actions.contract_FJ(data).then((res) => {
           var u = navigator.userAgent;
           var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
           var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
           if(isAndroid){
             window.open(res.content)
           }else{
             window.location.href = res.content
           }
        // this.$router.push({ name: "facescan", query: { url: res.content } });
      });
    }
  },
};
</script>

<style scoped lang="scss">
.my-info-browsinghistory {
  color: #333333;
  .f-nav {
    height: 0.8rem;
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    height: 1rem;
    .nav {
      width: 50%;
      font-size: 0.3rem;
      text-align: center;
      font-weight: 600;
      display: flex;
      align-items: center;
      .change-line {
        display: inline-block;
        width: 0.3rem;
        height: 0.06rem;
      }
      .change-line-active {
        display: inline-block;
        width: 0.3rem;
        height: 0.06rem;
        background-image: linear-gradient(to right, #f5e2b8, #edbd59);
        border-radius: 0.06rem;
      }
      .nav-block {
        margin: 0 auto;
      }
    }
    .active-nav {
      color: #ecb94c;
    }
  }
  .change-type {
    margin-top: 0.3rem;
    .tag {
      font-size: 0.24rem;
      height: 0.6rem;
      line-height: 0.6rem;
      padding: 0 0.5rem;
      background: #f8f8f8;
      display: inline-block;
      margin-left: 0.1rem;
    }
    .active-tag {
      background: #fbf2e1;
      color: #ecb94c;
    }
  }
  .contract-list {
    min-height: calc(100vh);
    padding: 0.2rem;
    .contract-block {
      overflow: hidden;
      display: block;
      background: #ffffff;
      border-radius: 0.1rem;
      margin-bottom: 0.3rem;
      .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.8rem;
        padding: 0 0.2rem;
        border-bottom: 0.01rem solid #eeeeee;
        overflow: hidden;
        position: relative;
        .head-left {
          font-size: 0.3rem;
          font-weight: 600;
        }
        .head-right {
          position: relative;
          color: #ffffff;
          font-size: 0.24rem;
          background: #ecb94c;
          transform: rotate(45deg);
          width: 1.13rem;
          height: 1.13rem;
          display: flex;
          align-items: flex-end;
          justify-content: space-around;
          top: -0.37rem;
          left: 0.76rem;
        }
        .head-right-new {
          position: relative;
          color: #ffffff;
          font-size: 0.24rem;
          background: #ecb94c;
          display: inline-block;
          padding: 0.1rem 0.3rem;
          border-radius: 0.3rem;
        }
      }
      .body {
        padding-bottom: 0.2rem;
        border-bottom: 0.01rem solid #eeeeee;
        .line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.24rem;
          margin-top: 0.24rem;
          line-height: 0.36rem;
          padding: 0 0.2rem;
          .line-pram {
            color: #747474;
            width: 1.5rem;
          }
          .line-text {
            width: 3.67rem;
            text-align: right;
          }
        }
        .y-color {
          color: #ecb94c;
        }
      }
      .active {
        padding: 0.3rem 0;
        .active-line {
          align-items: center;
          padding: 0 0.2rem;
          .active-pram {
            font-size: 0.3rem;
            font-weight: 600;
          }
          .progress-block {
            margin-top: 0.2rem;
            width: 6.7rem;
            background: #eeeeee;
            border-radius: 0.1rem;
            padding: 0.25rem;
            .progress-line {
              display: flex;
              align-items: center;
              margin-top: 0.2rem;
              .p-pram {
                position: relative;
                display: flex;
                align-items: center;
                .point {
                  height: 0.2rem;
                  width: 0.2rem;
                  border-radius: 0.2rem;
                  background: #ecb94c;
                }
                .line {
                  display: inline-block;
                  height: 0.8rem;
                  width: 0.02rem;
                  background: #ecb94c;
                  position: relative;
                  top: 0.4rem;
                  left: -0.1rem;
                }
              }
              .p-text {
                margin-left: 0.2rem;
                .p-time {
                  font-size: 0.2rem;
                }
                .p-statu {
                  margin-top: 0.05rem;
                  font-size: 0.28rem;
                }
              }
            }
            .progress-line:nth-last-child(1) {
              .p-pram {
                position: relative;
                display: flex;
                align-items: center;
                .line {
                  display: none;
                }
              }
            }
          }
          .active-button-block {
            // margin-top: 0.3rem;
            text-align: right;
            .active-button {
              display: inline-block;
              padding: 0.15rem 0.3rem;
              font-size: 0.26rem;
              border: 0.01rem solid #333333;
              border-radius: 0.1rem;
              margin-left: 0.2rem;
            }
            .active-button-t {
              display: inline-block;
              padding: 0.15rem 0.3rem;
              font-size: 0.26rem;
              border: 0.01rem solid #ecb94c;
              border-radius: 0.1rem;
              margin-left: 0.2rem;
              background: #ecb94c;
              color: #ffffff;
            }
          }
        }
        .active-line:nth-last-of-type() {
          border-bottom: none;
        }
      }
    }
  }
}
.fontcolor {
  color: #ecb94c;
}
.buttoned{
  background-color: #ecb94c;
  border: none !important;
  color: #ffffff;

}
</style>

